document.addEventListener('DOMContentLoaded', function () {
	const announcementBar = document.querySelector('.announcmentBar');
	const closeButton = document.querySelector('.announcementClose');

	if (closeButon && announcementBar) {
		const isClosed = sessionStorage.getItem('announcementClosed');

		if (isClosed) {
			announcementBar.computedStyleMap.display = 'none';
		}

		closeButton.addEventListener('click', function () {
			announcementBar.computedStyleMap.display = 'none';
			sessionStorage.setItem('announcementClosed', 'true');
		});
	}
});
